import { useState } from 'react'
import { NavBarLinkItem } from '../../constants/NavigationConstants'
import './HamburgerMenu.css'
import NavBarLink from './NavBarLink'
import SearchBar from './SearchBar'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import MenuNetworkDropdown from 'src/components/NavBar/MenuNetworkDropdown'

type HamburgerMenuProps = {
  mainNavBarLinks: NavBarLinkItem[];
  updateNavBarSelection: (selectedIndex: number, optionIndex?: number) => void
};

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
                                                       mainNavBarLinks,
                                                       updateNavBarSelection
                                                     }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const toggleHamburgerDropdown = (): void => {
    setIsOpen((click) => !click)
  }
  const closeHamburgerDropdown = (): void => {
    setIsOpen(false)
  }
  const HamburgerIcon = isOpen ? XMarkIcon : Bars3Icon
  return (
    <div className="hamburger-menu-wrapper">
      <HamburgerIcon className="hamburger-menu-icon" onClick={toggleHamburgerDropdown}/>
      {isOpen && (
        <div className="hamburger-menu-dropdown-container" onClick={closeHamburgerDropdown}>
          <div className="hamburger-menu-dropdown" onClick={(e) => e.stopPropagation()}>
            <SearchBar />
            {mainNavBarLinks.map((navBarLink, index) => (
              <NavBarLink
                key={index}
                id={index}
                navBarLink={navBarLink}
                onUpdateSelection={updateNavBarSelection}
                closeHamburgerMenu={toggleHamburgerDropdown}
              />
            ))
            }
            <MenuNetworkDropdown/>
          </div>
        </div>
      )}
    </div>
  )
}

export default HamburgerMenu
